<template>
    <div class="spinner-loader" v-show="spinnerVisible">
      <ProgressSpinner class="vertical-center" styleClass="custom-spinner" style="width:100px;height:100px" strokeWidth="4" fill="var(--surface-ground)" animationDuration="3s"/>
    </div>
</template>

<script>
import axios from 'axios';
import ProgressSpinner from './ProgressSpinner.vue'

export default {
    components: {
        ProgressSpinner,
    },
    data() {
        return {
            spinnerVisible: false,
            pendingRequests: 0,
            requestInterceptor: null,
            responseInterceptor: null,
            blacklist: [{
                method: "get",
                url: "/api/v1/account/notifications/counter"
              },{
                method: "get",
                url: "/api/v2/account/notifications/counter"
              },{
                method: "post",
                url: "/api/v1/account/notifications/read"
              },{
                method: "post",
                url: "/api/v2/account/notifications/read"
              },{
                method: "post",
                url: "/run-live"
              },{
                method: "post",
                url: "/api/v1/ai/bot/start"
              },{
                method: "post",
                url: "/api/v1/ai/bot/message"
              },{
                method: "get",
                url: "/api/v1/analytics/"
              },{
                method: "get",
                url: "/api/v1/energy/instant-power/"
              },{
                method: "get",
                url: "/api/v1/appliance/energy/chart"
              },{
                method: "get",
                url: "/api/v1/after-sales/spare-parts/cart"
              },{
                method: "post",
                url: "/api/v1/after-sales/documents/audit-log"
              }]
        };
    },
    mounted() {
        this.enableInterceptor();
    },
    beforeUnmount() {
      this.disableInterceptor();
    },
    methods: {
        enableInterceptor() {
            this.requestInterceptor = axios.interceptors.request.use(
                config => {
                  if (!this.isBlacklisted(config)) {
                    this.pendingRequests += 1;
                    this.spinnerVisible = true;
                  }
                  return config;
                },
                error => {
                    this.decrementPendingRequests(error?.config);
                    return Promise.reject(error);
                }
            );

            this.responseInterceptor = axios.interceptors.response.use(
                response => {
                  this.decrementPendingRequests(response?.config);
                  return response;
                },
                error => {
                    this.decrementPendingRequests(error?.config);
                    return Promise.reject(error);
                }
            );
        },

        disableInterceptor() {
            if (this.requestInterceptor !== null) {
              axios.interceptors.request.eject(this.requestInterceptor);
              this.requestInterceptor = null;
            }

            if (this.responseInterceptor !== null) {
              axios.interceptors.response.eject(this.responseInterceptor);
              this.responseInterceptor = null;
            }
        },

      decrementPendingRequests(config) {
        if (!config || this.isBlacklisted(config)) {
          return;
        }

        this.pendingRequests = Math.max(0, this.pendingRequests - 1);
        this.spinnerVisible = this.pendingRequests > 0;
      },

      isBlacklisted(config) {
        if (!config || !config.url || !config.method) {
          return false;
        }

        for (let i = 0; i < this.blacklist.length; i++) {
          if (config.method.toLowerCase() === this.blacklist[i].method && config.url.includes(this.blacklist[i].url)) {
            return true;
          }
        }
        return false;
      }
    },
};
</script>

<style lang="scss">
.spinner-loader {
    position: fixed;
    left: 0;
    height: 100%;
    top: 0;
    right: 0;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.2);
    z-index: 9998;
}
.spinner-loader .vertical-center {
    margin: 0;
    position: absolute;
    top: calc(50% - 50px);
    left: calc(50% - 50px);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
}

</style>
